/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TxPlanTemplates1/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AddAction from './AddAction/index'
import LocationChooser from './LocationChooser/index'
import Locations from './Locations/index'
import React from 'react'
import ShowDeletedAction from './ShowDeletedAction/index'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
let TxPlanTemplates = React.lazy(() => import('./TxPlanTemplates/index'))



/** @type {import('Simple/types.js').View} */
export default function TxPlanTemplates1({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentPlanTemplates/TxPlanTemplates"
  
}) {
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="TxPlanTemplates.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-2i6u6C': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="TxPlanTemplates.Vertical:1"
  data-view-path={viewPath}
 style={{'--pl-2-2i6u6C': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-2i6u6C': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="TxPlanTemplates.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 text="Treatment plan templates"
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="medium"
 marginTop={dtSpaceXs}
 color={dtColorsNeutral500}
 text="Manage treatment plan templates for each location. Add new templates and edit existing ones."
/>
<LocationChooser
  viewPath={`${viewPath}/LocationChooser`}
/>
<Locations
  viewPath={`${viewPath}/Locations`}
/>
</div>
<div
  data-testid="TxPlanTemplates.Vertical:2"
  data-view-path={viewPath}
 style={{'--mt-4-2i6u6C': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical2}`}
>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
/>
<div
  data-testid="TxPlanTemplates.Vertical:3"
  data-view-path={viewPath}
 style={{'--pl-2-2i6u6C': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-2i6u6C': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pt-1-2i6u6C': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical3}`}
>
<div
  data-testid="TxPlanTemplates.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<div
  data-testid="TxPlanTemplates.Vertical:4"
  data-view-path={viewPath}
 className="views-block"
>
<ShowDeletedAction
  viewPath={`${viewPath}/ShowDeletedAction`}
/>
</div>
<AddAction
  viewPath={`${viewPath}/AddAction`}
/>
</div>
<SuspenseBoundary
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<TxPlanTemplates
{...childProps}
  viewPath={`${viewPath}/TxPlanTemplates`}
/>
)}
</SuspenseBoundary>
</div>
</div>
</div>
{children}
</React.Fragment>)
}